import { Outlet, Navigate, Link } from "react-router-dom";
import { useState } from "react";

import settings from "../config/settings.json";
import logo from "../assets/logo-1.png";
import Footer from "./Footer";

const Layout = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  if (settings.comingSoon) {
    return <Navigate to="/coming-soon" />;
  }

  return (
    <div className="min-h-screen bg-white">
      {/* Modern Navigation Header */}
      <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-md border-b border-gray-200 z-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center space-x-3">
              <img className="h-12 w-auto" src={logo} alt="SM Constructions" />
              <div className="text-xl font-bold text-slate-800">
                SM Constructions
              </div>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center space-x-8">
              <Link
                to="/"
                className="text-slate-700 hover:text-amber-600 font-medium transition duration-300"
              >
                Home
              </Link>
              <Link
                to="/services"
                className="text-slate-700 hover:text-amber-600 font-medium transition duration-300"
              >
                Services
              </Link>
              <Link
                to="/contact"
                className="text-slate-700 hover:text-amber-600 font-medium transition duration-300"
              >
                Contact
              </Link>
            </nav>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden p-2 rounded-lg hover:bg-gray-100"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <svg
                className="w-6 h-6 text-slate-800"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                {isMenuOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>

          {/* Mobile Navigation Menu */}
          {isMenuOpen && (
            <div className="md:hidden py-4 border-t border-gray-200">
              <div className="flex flex-col space-y-4">
                <Link
                  to="/"
                  className="text-slate-700 hover:text-amber-600 font-medium transition duration-300 py-2"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Home
                </Link>
                <Link
                  to="/services"
                  className="text-slate-700 hover:text-amber-600 font-medium transition duration-300 py-2"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Services
                </Link>
                <Link
                  to="/contact"
                  className="text-slate-700 hover:text-amber-600 font-medium transition duration-300 py-2"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Contact
                </Link>
              </div>
            </div>
          )}
        </div>
      </header>

      {/* Main Content */}
      <main className="pt-20">
        <Outlet />
        <Footer />
      </main>
    </div>
  );
};

export default Layout;
